// extracted by mini-css-extract-plugin
export default {"topMainDiv":"HeaderTopDiv_topMainDiv__Az1q6","topMidDiv":"HeaderTopDiv_topMidDiv__XwDrr","socialLink":"HeaderTopDiv_socialLink__0ZY55"};